<template>
  <teleport to="body">
    <div
      v-if="dialogStore.isDownloadAppDialogVisible"
      class="download-app-mask"
      role="dialog"
      aria-modal="true"
      aria-labelledby="download-app-dialog-title"
      @click.self="dialogStore.closeDownloadAppDialog"
    >
      <div class="download-app-dialog">
        <button
          type="button"
          class="download-app-dialog__close"
          aria-label="关闭"
          @click="dialogStore.closeDownloadAppDialog"
        >
          <span class="download-app-dialog__close-icon" aria-hidden="true" />
        </button>
        <header class="download-app-dialog__header">
          <img
            class="download-app-dialog__logo"
            src="https://static.zaohaowu.com/TestData/tmp/static-resource/fc5e1e99-55ec-4a6e-aa91-1cc21e990185.png"
            alt=""
          />
          <h2 id="download-app-dialog-title" class="download-app-dialog__title">造好物 App</h2>
        </header>
        <div class="download-app-dialog__divider" />
        <div class="download-app-dialog__cards">
          <div class="download-app-card download-app-card--ios">
            <div class="download-app-card__pill">
              <i class="hitems-apple-fill" />
              <span>下载最新 iOS 版本</span>
            </div>
            <p class="download-app-card__hint">扫描二维码下载</p>
            <img class="download-app-card__qr" :src="iosQrSrc" alt="iOS 下载二维码" />
          </div>
          <div class="download-app-card download-app-card--android">
            <div class="download-app-card__pill">
              <i class="hitems-Android" />
              <span>下载最新 Android 版本</span>
            </div>
            <p class="download-app-card__hint">扫描二维码下载</p>
            <img class="download-app-card__qr" :src="androidQrSrc" alt="Android 下载二维码" />
          </div>
        </div>
        <div class="download-app-dialog__footer" v-if="dialogStore.downloadAppDialogFooterText">
          <p
            class="download-app-dialog__footer_text"
            v-for="item in downloadAppDialogFooterTextArr"
            :key="item"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
  import { useDialogStore } from '@/stores/dialog'
  import { computed } from 'vue'

  defineOptions({ name: 'DownLoadAppDialog' })

  const dialogStore = useDialogStore()
  const downloadAppDialogFooterTextArr = computed(() => {
    return dialogStore.downloadAppDialogFooterText.split('\n') || []
  })
  /** 可配置 VITE_APP_DOWNLOAD_QR_IOS / VITE_APP_DOWNLOAD_QR_ANDROID */
  const iosQrSrc =
    'https://static.zaohaowu.com/TestData/tmp/static-resource/c5ce5209-ab61-4247-81ad-c96953bba7cd.jpg'

  const androidQrSrc =
    'https://static.zaohaowu.com/TestData/tmp/static-resource/c5ce5209-ab61-4247-81ad-c96953bba7cd.jpg'
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
